import { render, staticRenderFns } from "./shopcart.vue?vue&type=template&id=4fc349f2&"
import script from "./shopcart.vue?vue&type=script&lang=js&"
export * from "./shopcart.vue?vue&type=script&lang=js&"
import style0 from "./shopcart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shopcart.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports